export default __webpack_public_path__ + "img/arrow-right.607829c1.svg";